import {
  SET_GRANTFIT_ERROR,
  SET_GRANTFIT_QUOTA,
  SET_GRANTFIT_SAVED_DETAILS,
  SET_GRANTFIT_SUMMARIES,
  SET_GRANTFIT_SUMMARIES_LOADING,
  UPDATE_GRANTFIT_SUMMARY
} from 'store/actions/grantfit'

const initialState = {
  isLoading: true,
  savedDetails: null,
  summaries: [],
  quota: null,
  error: null
}

const grantFitReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_GRANTFIT_ERROR:
      const { error } = payload
      return { ...state, error }
    case SET_GRANTFIT_QUOTA:
      const { quota } = payload
      return { ...state, quota }
    case SET_GRANTFIT_SAVED_DETAILS:
      const { details } = payload
      return { ...state, savedDetails: details }
    case SET_GRANTFIT_SUMMARIES_LOADING:
      const { isLoading } = payload
      return { ...state, isLoading }
    case SET_GRANTFIT_SUMMARIES:
      const { summaries } = payload
      return { ...state, summaries }
    case UPDATE_GRANTFIT_SUMMARY:
      const { summary } = payload
      return {
        ...state,
        summaries: [...state.summaries.filter(s => s.program != summary.program), summary]
      }
    default:
      return state
  }
}

export default grantFitReducer
